import orderResolver from "./order";
import userResolver from "./user";

const resolvers = {
  ...orderResolver,
  ...userResolver,
};

export default resolvers;
